import { jsxs, jsx } from "react/jsx-runtime";
import { Tabs, spaceMixin, mediaMixin } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import styled, { css } from "styled-components";
import { omitUndefined } from "../../utils/lodash.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig, DEFAULT_VALUES_SHAPE } from "./AffordabilityCalculator.utils.esm.js";
import AffordabilityChart from "./AffordabilityChart.esm.js";
import AffordabilityFields from "./AffordabilityFields.esm.js";
import AffordabilityVisual from "./AffordabilityVisual/AffordabilityVisual.esm.js";
import FullReportButton from "./FullReportButton.esm.js";
const StyledCalculatorForm = styled(CalculatorForm).withConfig({
  displayName: "AffordabilityCalculator__StyledCalculatorForm",
  componentId: "sc-1wuh2o2-0"
})(["padding-bottom:", ";display:flex;flex-direction:column-reverse;", ";"], spaceMixin("md"), mediaMixin("lg", css(["flex-direction:row;justify-content:space-between;"])));
const StyledFields = styled(AffordabilityFields).withConfig({
  displayName: "AffordabilityCalculator__StyledFields",
  componentId: "sc-1wuh2o2-1"
})(["flex-shrink:0;", " ", ""], mediaMixin("md", css(["flex-basis:30%;"])), mediaMixin("lg", css(["margin-right:", ";"], spaceMixin("md"))));
const StyledTabsContainer = styled.div.withConfig({
  displayName: "AffordabilityCalculator__StyledTabsContainer",
  componentId: "sc-1wuh2o2-2"
})(["position:relative;", ";"], mediaMixin("md", css(["flex-basis:65%;"])));
const AffordabilityCalculator = ({
  defaultValues,
  editorMode
}) => /* @__PURE__ */ jsxs(StyledCalculatorForm, { editorMode, fieldStorageKey: "affordabilityFields", calcTypeForMarketing: "Affordability", defaultValues: {
  [FieldConfig.customPayment.name]: false,
  [FieldConfig.maximumPayment.name]: 3500,
  [FieldConfig.annualIncome.name]: 7e4,
  [FieldConfig.monthlyDebts.name]: 250,
  [FieldConfig.downPayment.name]: 2e4,
  [FieldConfig.dti.name]: 36,
  [FieldConfig.rate.name]: 5,
  [FieldConfig.term.name]: 360,
  [FieldConfig.includePMI.name]: true,
  [FieldConfig.includeTaxesInsurance.name]: true,
  [FieldConfig.propertyTaxRate.name]: 1.2,
  // 225000 * 0.00035 * 12,
  [FieldConfig.annualHomeownersInsurance.name]: 945,
  [FieldConfig.monthlyHOA.name]: 0,
  [FieldConfig.monthlyPayment.name]: 1850,
  ...omitUndefined(defaultValues)
}, children: [
  /* @__PURE__ */ jsx(StyledFields, {}),
  /* @__PURE__ */ jsxs(StyledTabsContainer, { children: [
    /* @__PURE__ */ jsxs(Tabs, { defaultSelected: "home-price-tab", children: [
      /* @__PURE__ */ jsxs(Tabs.List, { "aria-label": "Default tabs example", children: [
        /* @__PURE__ */ jsx(Tabs.Tab, { id: "home-price-tab", "aria-controls": "home-price-panel", type: "button", children: "Home price" }),
        /* @__PURE__ */ jsx(Tabs.Tab, { id: "payment-tab", "aria-controls": "payment-panel", type: "button", children: "Payment" })
      ] }),
      /* @__PURE__ */ jsxs(Tabs.Panels, { children: [
        /* @__PURE__ */ jsx(Tabs.Panel, { id: "home-price-panel", "aria-labelledby": "home-price-tab", children: /* @__PURE__ */ jsx(AffordabilityVisual, {}) }),
        /* @__PURE__ */ jsx(Tabs.Panel, { id: "payment-panel", "aria-labelledby": "payment-tab", children: /* @__PURE__ */ jsx(AffordabilityChart, {}) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(FullReportButton, {})
  ] })
] });
AffordabilityCalculator.defaultProps = {
  defaultValues: void 0,
  editorMode: void 0
};
AffordabilityCalculator.propTypes = {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
};
export {
  DEFAULT_VALUES_SHAPE,
  AffordabilityCalculator as default
};
